export default {"src":"/_next/static/media/icon-4.e5ebb9ac.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};